import React from 'react';
import { Group } from 'react-konva';

const AuxiliaryInfo = (props) => {

    return (
        <Group>
            {null}
        </Group>
    )
};

export default AuxiliaryInfo;